import {LegacyWBIcon} from '@wandb/weave/common/components/elements/LegacyWBIcon';
import React from 'react';
import {Button} from 'semantic-ui-react';

import {type PaginationProps} from './types';

export type {PaginationProps};

const PaginationComp = ({
  tilePagination: {start, size, total},
  panelViewerRef,
  updateConfig,
}: PaginationProps) => {
  const nextDisabled: boolean = start + size >= total;
  const prevDisabled: boolean = start <= 0;
  const pageStart = start + 1;
  const pageEnd = Math.min(start + size, total);
  return (
    <div className="inline-pagination">
      <div className="pagination-count text-sm">
        {pageStart} - {pageEnd} of {total}
      </div>
      <Button.Group className="pagination-buttons">
        <Button
          size="tiny"
          disabled={prevDisabled}
          className="wb-icon-button only-icon page-down-button"
          onClick={() => {
            updateConfig({
              page: {start: Math.max(0, start - size)},
            });
          }}>
          <LegacyWBIcon name="previous" />
        </Button>
        <Button
          size="tiny"
          disabled={nextDisabled}
          className="wb-icon-button only-icon page-down-button"
          onClick={() => {
            const maxOffset = Math.floor(total / size) * size;
            updateConfig({
              page: {start: Math.min(start + size, maxOffset)},
            });
            if (panelViewerRef.current) {
              panelViewerRef.current.scrollTop = 0;
            }
          }}>
          <LegacyWBIcon name="next" />
        </Button>
      </Button.Group>
    </div>
  );
};
export const Pagination: React.FC<PaginationProps> = React.memo(PaginationComp);
